<script>
import CommonTableComponent from "@/components/table.vue";
import tableSearch from "@/mixins/tableSearch";
import router from "@/mixins/router";
import Layout from "@/views/layouts/main.vue";
import apiEndpoints from "@/services/apiEndpoints";
import DatePicker from "vue2-datepicker";
import DailyReportInfo from "@/views/pages/daily_reports/components/daily_report_info.vue";
import WasteInput from "@/views/pages/daily_reports/components/waste_input.vue";
import ServiceInput from "@/views/pages/daily_reports/components/service_input.vue";
import CarInput from "@/views/pages/daily_reports/components/car_input.vue";
import InputButtons from "@/views/pages/daily_reports/components/input_buttons.vue";
import ApproveButtons from "@/views/pages/daily_reports/components/approve_buttons.vue";
import ApproveMaintenanceButtons from "@/views/pages/daily_reports/components/approve_maintenance_buttons.vue";
import CreateMaintenanceButtons from "@/views/pages/daily_reports/components/create_maintenance_buttons.vue";
import WastesAfterTreatment from "@/views/pages/daily_reports/modals/Wastes.vue";
import number from "@/mixins/number";
import sweetAlert from "@/mixins/sweetAlert";
import scrollToError from "@/mixins/scrollToError";
import SelectWasteOrServiceModal from "@/views/pages/daily_reports/modals/SelectWasteOrServiceModal.vue";
import DailyReportControlRules from "@/services/DailyReportControlRules";
import dailyReportControlRules from "@/mixins/dailyReportControlRules";
import user from "@/mixins/user";
import manifestCreate from "@/mixins/manifestCreate";
import routerRedirectly from "@/mixins/daily_reports/routerRedirectly";
import appConfig from "@/app.config.json";
import ModalApprovalHistory from "@/views/pages/daily_reports/modals/ModalApprovalHistory";

export default {
  name: "daily_reports.input",
  page() {
    return {
      title: this.titlePage,
      meta: [{ name: "description", content: appConfig.description }]
    }
  },
  mixins: [router, tableSearch, number, sweetAlert, scrollToError, dailyReportControlRules, user, manifestCreate, routerRedirectly],
  components: {
    SelectWasteOrServiceModal,
    Layout,
    CommonTableComponent,
    DatePicker,
    DailyReportInfo,
    WastesAfterTreatment,
    WasteInput,
    ServiceInput,
    InputButtons,
    ApproveButtons,
    ApproveMaintenanceButtons,
    CreateMaintenanceButtons,
    CarInput,
    ModalApprovalHistory,
  },
  data() {
    return {
      dailyReport: {},
      vendorSite: {},
      wastesOrServicesByDailyReport: [],
      currentWasteOrService: {},
      isLoading: false,
      errors: {},
      controlRules: null,
      disableCancelFields: false,
      disableCompleteFields: false,
      transportCompletedText: '運搬',
      treatmentAcceptedText: '搬入',
      treatmentCompletedText: '処分',
      approveComment: '',
      cars: {},
    };
  },
  created() {
    this.getData();
  },
  methods: {
    getControlRules(workOrderType, zzOwn, vendorSiteSelect) {
      const ruleControl = new DailyReportControlRules();
      this.controlRules = ruleControl.getAllControlRules(workOrderType, zzOwn, vendorSiteSelect);
    },
    confirmCreateMaintenancePage() {
      this.confirm(
        '',
        '',
        '作業日報を追加登録してもよろしいですか。<br>追加した日報は自動的に承認されます。',
        'info',
        'OK',
        'キャンセル'
      ).then(async (result) => {
        if (result.isConfirmed) {
          await this.submitInput();
        }
      });
    },
    async submitInput(fromDelete = false, isTemp = false) {
      this.errors = {};

      let params = this.prepareParams();
      params.isTemp = isTemp;
      params.isApprove = false;

      if (params.wastes_or_services_by_daily_report && params.wastes_or_services_by_daily_report.length > 0) {
        let wasteOrService = params.wastes_or_services_by_daily_report[0];
        if (wasteOrService.new) {
          // 日報メンテナンス追加の場合
          if(wasteOrService.is_waste){
            // 合計の数量が0でNGではなく、全て空欄ならNGにしたい
            let estimates = wasteOrService.estimates_by_daily_report;
            // let sumQuantity = 0;
            // estimates.forEach(estimate => {
            //   const quantity = estimate.quantity ? parseInt(estimate.quantity) : 0;
            //   sumQuantity += quantity;
            // });
            let setEstimates = null;
            setEstimates  = estimates.filter(item => item.quantity !== null);

            //if (sumQuantity === 0) {
            if(setEstimates.length == 0) {
              this.errors['wastes_or_services_by_daily_report.0.estimates_by_daily_report.quantity'] = ['少なくとも1つ数量を入力してください。'];
              return;
            }
          }

          // 追加した際には承認が行われるため、まだ立っていないことを考慮して「完了」フラグを立てる必要がある
          let workOrderType = this.dailyReport.work_order_json.zz_work_order_type_id; // 作業分類
          // 排出は追加は出来ないので考えなくてよい
          switch(workOrderType){
            case this.$constant.work_order_type.work: // 作業→運搬扱いなので運搬完了
            case this.$constant.work_order_type.other: // その他→同上
            case this.$constant.work_order_type.transportation: // 運搬→運搬のみ
            case this.$constant.work_order_type.transshipment_storage: // 積替え保管→運搬と同様
              // ここでフラグを設定
              params.daily_report.is_transport_completed = 1;
              break;
            case this.$constant.work_order_type.disposal: // 処分　搬入完了は必ず立てる。処分終了日が入力されていたら処分完了フラグも立てる。
              // どの工場かを知る必要がある
              // 処分場のsite_idがjsonのtransport_contracts[0].vendor_site_id_sectionNと一致するzz_vendor_site_4_idが該当工場
              let jsonTransportContract = this.dailyReport.work_order_json.transport_contracts[0];
              let factoryNo = null;

              let ownVendorSites = this.$store.getters["options/own_vendor_sites"] ?? [];

              // for(let i = 1 ; i < 6 ; i++){
              //   if(jsonTransportContract['vendor_site_id_section'+i].id == wasteOrService.vendor_site_id_of_treatment){
              //     factoryNo = jsonTransportContract['vendor_site_id_section'+i].zz_vendor_site_4_id;
              //     break;
              //   }
              // }
              // 廃棄物が追加された場合は廃棄物が運搬先（処分場）を持っているのでこれでいいが
              // 「完了されていない状態でサービスが追加された場合」、サービスは運搬先を持っていないので
              // 開いている工場の完了フラグを立てる必要がある
              if(params.wastes_or_services_by_daily_report[0].is_waste){
                for(let i = 0 ; i < ownVendorSites.length ; i++){
                  if(ownVendorSites[i].id == wasteOrService.vendor_site_id_of_treatment){
                    factoryNo = ownVendorSites[i].zz_vendor_site_4_id;
                    break;
                  }
                }
              }else{
                for(let i = 0 ; i < ownVendorSites.length ; i++){
                  if(ownVendorSites[i].id == this.vendorSiteId){
                    factoryNo = ownVendorSites[i].zz_vendor_site_4_id;
                    break;
                  }
                } 
              }

              // 搬入完了
              params.daily_report['is_treatment_accepted_' + factoryNo] = 1;

              // 処分完了か？
              // 処分完了フラグは処分終了日が入力されていたら明細のほうを立てる
              // さらにサービスの場合は処分関係ないので2にする
              if(!wasteOrService.is_waste){
                params.wastes_or_services_by_daily_report[0].treatment_complete = 2;
              }else if(wasteOrService.treatment_completed_date){
                // params.daily_report['is_treatment_completed_' + factoryNo] = 1;
                params.wastes_or_services_by_daily_report[0].treatment_complete = 1;
              }else{
                params.wastes_or_services_by_daily_report[0].treatment_complete = 0;
              }
              break;
            case this.$constant.work_order_type.transportation_disposal: // 収集運搬処分
              // 処分から入れようとすると運搬が入っていないのでエラーになる
              // そのため必ず運搬から入れる、流れ的に運搬完了→処分完了という扱いになるはず（そのUIもどうなん？）
              params.daily_report.is_transport_completed = 1; // 運搬終了は必ず
              // 処分完了か？
              if(wasteOrService.treatment_completed_date){
                //params.daily_report['is_treatment_completed_' + factoryNo] = 1;
                params.wastes_or_services_by_daily_report[0].treatment_complete = 1;
              }else{
                params.wastes_or_services_by_daily_report[0].treatment_complete = 0;
              }

              break;
            default:
              break;
          }

        }

        // 一時保存でも工場日報の場合、「処分終了年月日が入力されていない場合処分完了フラグを倒す」はやったほうがいい。
        // 日付が入っていないのに完了のままだとそのまま承認できてしまうロジックのため。
        // 立てるのは逆にやっちゃダメ
        if(this.vendorSite && this.zzVendorSiteIndex){
          params.wastes_or_services_by_daily_report.map(
            function(item){ 
              if(item.treatment_completed_date != null){
              }else{
                item.treatment_complete = 0;
              }
            }
          );
        }
      }

      const url = apiEndpoints.input_daily_report(this.dailyReportId, this.vendorSiteId);

      const {status, data, code} = await this.$http.post(url, params);

      // 削除時の更新の場合ここで処理を中断する
      if(fromDelete){
        return {status: status, data: data, code: code};
      }

      if (status) {
        this.successToast("作業日報を登録しました", false, 2000);
        if (this.isInputPage) {
          return this.backByInputPage();
        }
        if (this.isApproveMaintenancePage) {
          return this.backByApproveMaintenancePage();
        }
        if (this.isCreateMaintenancePage) {
          // マニフェストを作る場合wastesOrServicesByDailyReportがないといけない。
          // この画面でいうidはdailyReportのidなのでinsertした際のidを取り出す必要がある。
          let newId = data.result.result_process_wastes_or_services.wastesOrServices[0].id;
          await this.handelCreateManifestWhenApprove(data.result.result_process_calculate_co2, newId);
          return this.backByCreateMaintenancePage();
        }
      }

      if (this.$helpers.isDisplayFormError(code)) {
        this.errors = data.errors;
        return this.$nextTick(() => {
          this.scrollIntoError();
        });
      } else if (this.$helpers.isDisplayErrorInLocalComponent(code)) {
        if (data.approved_input) {
          return this.alertApprovedWastesOrServices(data.message)
        }
        return this.errorToast(data.message);
      }
    },
    prepareParams() {
      const dailyReportClone = this.$_.cloneDeep(this.dailyReport);
      delete dailyReportClone.work_order_json;
      delete dailyReportClone.schedule;

      const wastesOrServicesByDailyReportClone = this.$_.cloneDeep(this.wastesOrServicesByDailyReport);
      wastesOrServicesByDailyReportClone.forEach(item => {
        item.wastes_after_treatment_by_daily_report.forEach(wasteAfterTreatment => {
          delete wasteAfterTreatment.pivot;
        });
        item.estimates_by_daily_report.forEach(estimate => {
          delete estimate.pivot
          delete estimate.zz_unit
          delete estimate.waste
        });
      });

      return {
        daily_report: dailyReportClone,
        wastes_or_services_by_daily_report: wastesOrServicesByDailyReportClone,
        cars_by_daily_report: this.carsByWorkOrder,
        approve_comment: this.approveComment
      };
    },
    isApproveSidePage(){
      if(this.isApprovePage || this.isMaintenanceSidePage()) return true;
      return false;
    },
    isMaintenanceSidePage(){
      if(this.isApproveMaintenancePage || this.isCreateMaintenancePage) return true;
      return false;
    },

    async getData() {
      this.isLoading = true;

      const url = apiEndpoints.detail_daily_report_with_wastes_or_services(this.dailyReportId, this.vendorSiteId);
      const {status, data, code} = await this.$http.getWithLoading(url, {
        vendor_site_id: this.vendorSiteId,
        waste_or_service_ids: this.wasteOrServiceIds,
      });

      this.isLoading = false;

      this.cars = null;

      if (status) {
        let workOrderType = data?.result?.daily_report?.work_order_json?.zz_work_order_type_id;
        if (workOrderType === this.$constant.work_order_type.transshipment_storage) {
          workOrderType = workOrderType + '_' + data?.result?.daily_report?.schedule?.transport_and_hold_section;
        }
        let zzOwnId = data?.result?.daily_report?.schedule?.vendor?.zz_own_id;
        if ([this.$constant.work_order_type.work,this.$constant.work_order_type.others].includes(workOrderType)) {
          zzOwnId = null;
        }
        this.getControlRules(workOrderType, zzOwnId, !!this.vendorSiteId);
        if (this.isInputPage) {
          return this.mappingDataInputPage(data.result);
        }

        if (this.isApprovePage) {
          this.cars = data.result.cars;
          return this.mappingDataApprovePage(data.result);
        }

        if (this.isApproveMaintenancePage) {
          this.cars = data.result.cars;
          return this.mappingDataApproveMaintenancePage(data.result);
        }

        if (this.isCreateMaintenancePage) {
          this.cars = data.result.cars;
          return this.mappingDataCreateMaintenancePage(data.result);
        }

        return
      }

      this.$router.go(-1)
    },
    mappingDataInputPage(data) {
      this.dailyReport = data.daily_report;
      // 各明細にオリジンのindexをつけながらサービスならサービスIDを持たせたい
      this.wastesOrServicesByDailyReport = data.daily_report.wastes_or_services_by_daily_report.map((x, index) => {
        x.origin_index = index;
        let waste_or_service_by_work_order = this.getTargetWasteOrServiceFromJson(x.wastes_or_services_by_work_order_id);
        // waste_or_service_by_work_orderはjsonを見なければいけない
        if (waste_or_service_by_work_order?.service_id) {
          x.service_id = waste_or_service_by_work_order?.service_id;
        }
        return x;
      });
      this.vendorSite = data.vendor_site;

      delete this.dailyReport.wastes_or_services_by_daily_report;
    },
    mappingDataApprovePage(data) {
      this.dailyReport = data.daily_report;
      if (data.daily_report.wastes_or_services_by_daily_report.length) {
        data.daily_report.wastes_or_services_by_daily_report[0].origin_index = 0;
        let waste_or_service_by_work_order = this.getTargetWasteOrServiceFromJson(data.daily_report.wastes_or_services_by_daily_report[0].wastes_or_services_by_work_order_id);
        if (waste_or_service_by_work_order?.service_id) {
          data.daily_report.wastes_or_services_by_daily_report[0].service_id = waste_or_service_by_work_order?.service_id;
        }
        this.wastesOrServicesByDailyReport = [data.daily_report.wastes_or_services_by_daily_report[0]];
      }
      this.vendorSite = data.vendor_site;

      delete this.dailyReport.wastes_or_services_by_daily_report;
    },
    mappingDataApproveMaintenancePage(data) {
      this.dailyReport = data.daily_report;
      if (data.daily_report.wastes_or_services_by_daily_report.length) {
        data.daily_report.wastes_or_services_by_daily_report[0].origin_index = 0;
        let waste_or_service_by_work_order = this.getTargetWasteOrServiceFromJson(data.daily_report.wastes_or_services_by_daily_report[0].wastes_or_services_by_work_order_id);
        if (waste_or_service_by_work_order?.service_id) {
          data.daily_report.wastes_or_services_by_daily_report[0].service_id = waste_or_service_by_work_order?.service_id;
        }
        this.wastesOrServicesByDailyReport = [data.daily_report.wastes_or_services_by_daily_report[0]];
        let notReservedEstimates = this.wastesOrServicesByDailyReport[0].estimates_for_maintenance;

        // 日報メンテナンス画面の場合は予約されていない廃棄物見積明細も結合して表示
        if(notReservedEstimates !== undefined){
          this.wastesOrServicesByDailyReport[0].estimates_by_daily_report = this.wastesOrServicesByDailyReport[0].estimates_by_daily_report.concat(notReservedEstimates);
        }
      }
      this.vendorSite = data.vendor_site;

      delete this.dailyReport.wastes_or_services_by_daily_report;
    },
    mappingDataCreateMaintenancePage(data) {
      this.dailyReport = data.daily_report;
      this.vendorSite = data.vendor_site;
      delete this.dailyReport.wastes_or_services_by_daily_report;
    },
    onOpenModalSelectWaste(wasteOrService) {
      // このwosはdailyreport
      this.$refs.wastesAfterTreatmentModal.openModal(
        wasteOrService.wastes_after_treatment_by_daily_report.map(x => x.id),
        this.getTargetWasteOrServiceFromJson(wasteOrService.wastes_or_services_by_work_order_id) // jsonのwosBywoを直接送る      
      );
      this.currentWasteOrService = wasteOrService;
    },
    onSelectedWastes(data) {
      if (!this.currentWasteOrService.id) return;

      const index = this.wastesOrServicesByDailyReport.findIndex(x => x.id === this.currentWasteOrService.id);
      if (index === -1) return;

      this.wastesOrServicesByDailyReport[index].wastes_after_treatment_by_daily_report = data;
    },
    onModalWastesAfterTreatmentHidden() {
      this.resetCurrentWasteOrService();
    },
    resetCurrentWasteOrService() {
      this.currentWasteOrService = null;
    },
    openApprovalHistoryModal() {
      if (this.wastesOrServicesByDailyReport.length == 0) {
        return;
      }
      const vendorSiteId = this.vendorSite ? this.vendorSite.id : null;
      this.$refs.modal_approval_history.openModal(this.wastesOrServicesByDailyReport[0].id, vendorSiteId);
    },
    getApproved(){
      //いずれかが承認されていればtrueを返す
      if(this.wastesOrServicesByDailyReport[0] == undefined) return false;
      return this.wastesOrServicesByDailyReport[0].transport_approved_status == "1" ||
      this.wastesOrServicesByDailyReport[0].treatment_approved_status == "1"
    },
    approveDisabled(){
      let data = this.wastesOrServicesByDailyReport[0];
      if(data == undefined) return false;
      // 日報がキャンセルされている場合承認できないようにする
      if(this.dailyReport.is_schedule_canceled == 1) return true;

      // 収集運搬処分で工場の場合、運搬が承認されていない場合NG
      if(this.$route.query.vendor_site_id && 
        this.dailyReport.work_order_json.zz_work_order_type_id == this.$constant.work_order_type.transportation_disposal &&
        data.transport_approved_status == "0"
      ){
        return true;
      }

      // パラメータにvondor_site_idがある場合工場
      if(this.$route.query.vendor_site_id && data.treatment_approved_status == "1"){
        return true;
      }else if(!this.$route.query.vendor_site_id && data.transport_approved_status == "1"){
        return true;
      }else{
        return false;
      }
    },
    confirmApprove() {
      let cfMessage = '';
      let successMessage = '';
      let confirmButtonText = 'OK';
      if (this.isApprovePage) {
        cfMessage = '作業日報を承認してもよろしいですか。';
        successMessage = '作業日報を承認しました';
        confirmButtonText = '承認'
      }
      if (this.isApproveMaintenancePage && this.approveDisabled()) {
        cfMessage = '作業日報を修正してもよろしいですか。<br>承認またはキャンセル済のため、連携済みの売上やマニフェストのデータは更新されません。';
        successMessage = '作業日報を修正しました';
      } else if (this.isApproveMaintenancePage) {
        cfMessage = '作業日報を登録してもよろしいですか。<br>未承認の日報は自動的に承認されます。';
        successMessage = '作業日報を登録しました';
      }

      this.confirm(
        '',
        '',
        cfMessage,
        'info',
        confirmButtonText,
        'キャンセル',
      ).then(async (result) => {
        if (result.isConfirmed) {
          await this.submitApprove(successMessage);
        }
      });
    },
    async submitApprove(successMessage) {
      this.errors = {};

      let params = this.prepareParams();
      params.isTemp = false;
      params.isApprove = true;

      if (this.isApproveMaintenancePage && this.approveDisabled()) {
        // 承認済の場合は日報を更新するだけ
        params['is_update'] = true;
      }

      if(this.vendorSiteId){
        var factoryId = null;
        // 工場で処分の場合、搬入完了を考慮する必要がある
        if(this.dailyReport?.work_order_json?.zz_work_order_type_id == this.$constant.work_order_type.disposal){
        // 処分終了年月日が入力されている場合は処分完了という扱いでよい
          if(params.wastes_or_services_by_daily_report[0].treatment_completed_date){
            //params.daily_report[`is_treatment_completed_${this.zzVendorSiteIndex}`] = 1;
            params.wastes_or_services_by_daily_report[0].treatment_complete = 1;
          }
          params.daily_report[`is_treatment_accepted_${this.zzVendorSiteIndex}`] = 1;
        }else if(this.dailyReport?.work_order_json?.zz_work_order_type_id == this.$constant.work_order_type.transportation_disposal){
          // 収集運搬処分の場合、工場側を承認する場合必ず処分終了になる。
          //params.daily_report[`is_treatment_completed_${this.zzVendorSiteIndex}`] = 1;
          params.wastes_or_services_by_daily_report[0].treatment_complete = 1;
        }else if(this.dailyReport?.work_order_json?.zz_work_order_type_id == this.$constant.work_order_type.discharge){
          // 搬出は処分は不要のため9を設定する。
          // ただし搬出は工場の完了フラグを立てないといけないので日報のフラグを立てる
          params.wastes_or_services_by_daily_report[0].treatment_complete = 9;
          // wosByDailyReport.vendorSiteは処分事業者なので、
          // 排出では他社になっている。
          // どの工場のフラグを立てるかはwork_order_json.case.discharger_site.zz_discharger_site_4_idを見るべき
          factoryId = this.dailyReport.work_order_json['case']['discharger_site']['zz_discharger_site_4_id'];
          params.daily_report[`is_treatment_completed_${factoryId}`] = 1;
        }else{
          // 積替えの工場の日報では排出事業者は他社になっている。
          // この場合はvendorSiteが積替え保管場になっているのでそっちを使ってよい
          params.wastes_or_services_by_daily_report[0].treatment_complete = 9;
          let vendorSite = this.vendorSite; 
          factoryId = vendorSite.zz_vendor_site_4_id;
          params.daily_report[`is_treatment_completed_${factoryId}`] = 1;
        }
      }else{
        // 運搬完了として承認する
        params.daily_report['is_transport_completed'] = 1;
      }

      const url = apiEndpoints.approve_daily_report(this.dailyReportId, this.vendorSiteId);

      const {status, data, code} = await this.$http.post(url, params);

      if (status) {
        this.successToast(successMessage, false, 2000);
        if (this.isApprovePage) {
          await this.handelCreateManifestWhenApprove(data.result.result_process_calculate_co2);
          return this.backByApprovePage();
        }
        if (this.isApproveMaintenancePage && this.approveDisabled()) {
          // 承認済の場合は日報を更新するだけ
          return this.backByApproveMaintenancePage();
        } else if (this.isApproveMaintenancePage) {
          await this.handelCreateManifestWhenApprove(data.result.result_process_calculate_co2);
          return this.backByApproveMaintenancePage();
        }
      }

      if (this.$helpers.isDisplayFormError(code)) {
        this.errors = data.errors;
        return this.$nextTick(() => {
          this.scrollIntoError();
        });
      } else if (this.$helpers.isDisplayErrorInLocalComponent(code)) {
        return this.errorToast(data.message);
      }
    },
    beforeSubmitDeleteWasteOrService() {
      this.confirm(
        '',
        '',
        '作業日報を削除してもよろしいですか',
      ).then(async (result) => {
        if (result.isConfirmed) {
          await this.submitDeleteWasteOrService();
        }
      });
    },
    async submitDeleteWasteOrService() {
      const wasteOrServiceId = this.wastesOrServicesByDailyReport[0].id;
      const url = apiEndpoints.delete_waste_or_service_by_daily_report(wasteOrServiceId);

      const {status, data, code} = await this.$http.post(url, {});
      if (status) {
        this.successToast("作業日報を削除しました", false, 3000);
        return this.backByApproveMaintenancePage();
      }

      if (this.$helpers.isDisplayFormError(code)) {
        this.errors = data.errors;
        return this.$nextTick(() => {
          this.scrollIntoError();
        });
      } else if (this.$helpers.isDisplayErrorInLocalComponent(code)) {
        return this.errorToast(data.message);
      }
    },
    alertApprovedWastesOrServices(message) {
      this.confirm(
        '',
        '',
        message,
        "warning", "OK", "", false
      ).then(async (result) => {
        window.location.reload();
      });
    },

    confirmUpdateWorkOrderInformation(){
      let cfMessage = '';
      let successMessage = '';
      let confirmButtonText = 'OK';

      cfMessage = '作業指示情報を更新してもよろしいですか。';
      successMessage = '作業指示情報を更新しました。';

      this.confirm(
        '',
        '',
        cfMessage,
        'info',
        confirmButtonText,
        'キャンセル',
      ).then(async (result) => {
        if (result.isConfirmed) {
          await this.updateWorkOrderInformation(successMessage);
        }
      });
    },
    async updateWorkOrderInformation(successMessage) {
      const url = apiEndpoints.daily_report_update_work_order_json(this.dailyReportId);

      const {status, data, code} = await this.$http.post(url, {});
  
      if (status) {
        this.successToast(successMessage, false, 2000);
        window.location.reload();
      }

      if (this.$helpers.isDisplayFormError(code)) {
        this.errors = data.errors;
        return this.$nextTick(() => {
          this.scrollIntoError();
        });
      } else if (this.$helpers.isDisplayErrorInLocalComponent(code)) {
        return this.errorToast(data.message);
      }
    },
    changePageTitle(vendor) {
      let title = '作業日報入力';
      if (this.$route.query.screen_parent != undefined) {
        if (this.$route.query.screen_parent == 'maintenance') title = '作業日報メンテナンス'
        if (this.$route.query.screen_parent == 'approve') title = '作業日報承認'
      }
      let titleName = '';
      if(this.dailyReport.work_order_json.work_order_type.id == this.$constant.work_order_type.discharge){
        titleName = this.dailyReport?.work_order_json?.case?.discharger_site?.name_abbreviated || '';
      }else{
        titleName =vendor.name_abbreviated || '';
      }
      this.$store.dispatch("layout/changeOverwritePageTitle", {
        title: `<div class="d-flex gap-4"><p>${title}</p><p>${titleName}</p></div>`,
      });
    },
    async onSelectedWastesOrService(dateEvent) {
      const ids = [...dateEvent];
      // get wastes or services by work order from api
      this.isLoading = true;

      const url = apiEndpoints.wastes_or_services_by_work_order();
      const {status, data, code} = await this.$http.getWithLoading(url, {
        ids: ids
      });

      this.isLoading = false;
      if (!status) {
        return;
      }

      this.wastesOrServicesByDailyReport = [];
      this.wastesOrServicesByDailyReport = data.result.map((wasteOrService, index) => {
        let estimates = [];
        if (wasteOrService.waste_id && wasteOrService.waste.estimates.length) {
          estimates = wasteOrService.waste.estimates.map(estimate => {
            return {
              ...estimate,
              quantity: null,
              number_of_rental_containers: '',
            }
          });
        } else if (wasteOrService.service_id && wasteOrService.service.estimates.length) {
          estimates = wasteOrService.service.estimates.map(estimate => {
            return {
              ...estimate,
              quantity: null,
              number_of_rental_containers: '',
            }
          });
        }

        let params = {
          'id': this.$_.uniqueId(),
          'date_of_issue': null,
          'zz_manifest_type_id': null,
          'manifest_number': null,
          'remarks': null,
          'transport_completed_date': null,
          'measurement_quantity': null,
          'zz_quantity_confirmation_unit_id': null,
          'treatment_completed_date': null,
          'zz_valuables_involved_type_id': null,
          'waste_or_service_by_work_order': wasteOrService,
          'estimates_by_daily_report': estimates,
          'wastes_after_treatment_by_daily_report': [],
          'wastes_or_services_by_work_order_id': wasteOrService.id,
          'is_waste': !!wasteOrService.waste_id,
          'transport_approved_status': null,
          'treatment_approved_status': null,
          'new': true,
          'origin_index': index,
          'disposal_site_list_of_after': wasteOrService.disposal_site_list_of_after ?? null,
          'own_disposal_site_count': wasteOrService.own_disposal_site_count ?? 0,
        };
        if (wasteOrService.service_id) {
          params.service_id = wasteOrService.service_id;
        }
        if(wasteOrService.disposal_site?.disposal_site_by_waste_category){
          params.vendor_site_id_of_treatment = wasteOrService.disposal_site.disposal_site_by_waste_category.vendor_site_id_of_treatment;
        }

        return params;
      });
    },
    backByInputPage() {
      this.backToDailyReport()
    },
    backByApprovePage() {
      return this.$router.push({
        name: 'daily.reports.search.approve',
        query: this.$route.query
      });
    },
    backByApproveMaintenancePage() {
      return this.$router.push({
        name: 'daily.reports.search.maintenance',
        query: this.$route.query
      });
    },
    backByCreateMaintenancePage() {
      return this.$router.push({
        name: 'daily.reports.search.maintenance',
        query: this.$route.query
      });
    },

    async getManifestByWOSDailyReportId(wasteOrServiceId, manifestNumber,manifestTypeId, co2Result = []) {
      this.isLoading = true;

      const url = apiEndpoints.get_info_waste_or_services_by_daily_report(wasteOrServiceId);
      const {status, data} = await this.$http.get(url);

      this.isLoading = false;

      if (status){
        this.mappingDataCreateManifest(data.result, manifestNumber, manifestTypeId, null, co2Result);
      }
      return false;

    },

    async createManifest() {

      this.isLoading = true;

      const url = apiEndpoints.create_manifest;
      const {status} = await this.$http.post(url, this.manifestCreate);

      this.isLoading = false;
      return status;

    },
    async handelCreateManifestWhenApprove(co2Result = [], newId = null){
      
      if (!this.wastesOrServicesByDailyReport[0]) return;
      
      // 作業分類作業・その他はマニフェストを作成しない
      if(this.dailyReport.work_order_json.zz_work_order_type_id == this.$constant.work_order_type.work ||
        this.dailyReport.work_order_json.zz_work_order_type_id == this.$constant.work_order_type.others
      ){
        return;
      }
      // サービスの場合はマニフェストを作成しない
      if(!this.wastesOrServicesByDailyReport[0].is_waste){
        return;
      }
      
      let manifestNumber = this.wastesOrServicesByDailyReport[0].manifest_number;
      // 「追加」の時は新規IDを優先する
      let wasteOrServiceId = newId ?? this.wastesOrServicesByDailyReport[0].id;
      let manifestTypeId = this.wastesOrServicesByDailyReport[0].zz_manifest_type_id

      let isAccept = await this.getManifestByWOSDailyReportId(wasteOrServiceId, manifestNumber,manifestTypeId, co2Result);
      if(isAccept){
        return;
      }

      await this.createManifest();
    },
    async toEditManifest() {

      let manifestId = this.wastesOrServicesByDailyReport[0].manifest_id;


      const objectStorage = {
        query: this.$route.query,
        daily_report_id: this.dailyReport.id,
      }
      this.supportLocalStorage({source: this.$route.name}, 'historyManifestEdit');
      this.supportLocalStorage(objectStorage, 'dailyReportInput');

      return this.$router.push({
        name: 'manifests.edit',
        params: {
          id: manifestId,
        }
      });
    },
    async deleteWasteOrServiceByInput (wasteOrServiceByDailyReport) {
      const id = [
        this.dailyReport.schedule_id,
        wasteOrServiceByDailyReport?.daily_report_sub_id,
      ].filter(x => !!x).join('-');

      this.confirm(
        '受付番号'+id+'の作業を削除してもよろしいですか。',
        '（他の枝番は一時保存されます）',
        ''
      ).then(async (result) => {
        if (!result.isConfirmed) return;
        // 削除する前に一時保存
        const {inputStatus, inputData, inputCode} = await this.preSave();
       
        // 一時保存で入力エラーや何かしらエラーがあった場合処理中断する

        if(!inputStatus){
          if (this.$helpers.isDisplayFormError(inputCode)) {
            this.errors = inputData.errors;
            return this.$nextTick(() => {
              this.scrollIntoError();
            });
          } else if (this.$helpers.isDisplayErrorInLocalComponent(inputCode)) {
            return this.errorToast(inputData.message);
          }
        }

        const url = apiEndpoints.delete_by_input_page_waste_or_service_by_daily_report(wasteOrServiceByDailyReport.id);

        const {status, data, code} = await this.$http.post(url, {});
        if (status) {
          window.location.reload();
        }

        if (this.$helpers.isDisplayFormError(code)) {
          this.errors = data.errors;
          return this.$nextTick(() => {
            this.scrollIntoError();
          });
        } else if (this.$helpers.isDisplayErrorInLocalComponent(code)) {
          return this.errorToast(data.message);
        }
      });
    },
    async preSave(){
      const {status, data, code} = await this.submitInput(true, true);
      return {inputStatus: status, inputData: data, inputCode: code,};
    },

    setValueCompleteFields(is_schedule_canceled) {
      if (is_schedule_canceled) {
        this.dailyReport[`is_treatment_accepted_${this.zzVendorSiteIndex}`] = false;
        this.dailyReport[`is_treatment_completed_${this.zzVendorSiteIndex}`] = false;
        this.dailyReport.is_transport_completed = false;
      }
      this.disableCompleteFields = !!is_schedule_canceled;
    },
    /**
     * キャンセル/キャンセル解除確認ダイアログ表示
     */
    onClickScheduleCanceled() {
      let cfMessage = "";
      let successMessage = "";
      let buttonType = "cencel";
      if(this.dailyReport.is_schedule_canceled){
        cfMessage = "キャンセルを解除します。よろしいですか。";
        successMessage = "キャンセルを解除しました。";
      }else{
        cfMessage = "キャンセルとして登録します。よろしいですか。";
        successMessage = "キャンセルとして登録しました。";
      }
      this.confirm(
        '',
        '',
        cfMessage,
        'info',
        'はい',
        'いいえ',
      ).then(async (result) => {
        if (result.isConfirmed) {
          await this.submitCancelCompleted(successMessage, buttonType);
        }
      });
    },
    /**
     * 「運搬完了」クリック時の確認ダイアログ表示
     */
    onClickTransportCompleted() {
      let cfMessage = "運搬完了として登録します。よろしいですか。";
      let successMessage = "運搬完了として登録しました。";
      let buttonType = "transport";
      this.confirm(
        '',
        '',
        cfMessage,
        'info',
        'はい',
        'いいえ',
      ).then(async (result) => {
        if (result.isConfirmed) {
          await this.submitCancelCompleted(successMessage,buttonType);
        }
      });
    },
    /**
     * 搬入完了確認ダイアログ表示処理
     * @param index
     */
    onClickTreatmentAccepted(index) {
      let cfMessage = "搬入完了として登録します。よろしいですか。";
      let successMessage = "搬入完了として登録しました。";
      let buttonType = "treatmentAccepted";
      this.confirm(
        '',
        '',
        cfMessage,
        'info',
        'はい',
        'いいえ',
      ).then(async (result) => {
        if (result.isConfirmed) {
          await this.submitCancelCompleted(successMessage,buttonType, index);
        }
      });
    },
    /**
     * 処分完了確認ダイアログ表示処理
     * @param index
     */
    onClickTreatmentCompleted(index, zzWorkOrderTypeId) {
      if(zzWorkOrderTypeId == '05' || zzWorkOrderTypeId == '06'){
        var cfMessage = "搬出完了として登録します。よろしいですか。";
        var successMessage = "搬出完了として登録しました。";
      }else if(zzWorkOrderTypeId == this.$constant.work_order_type.transportation_disposal){
        var cfMessage = "搬入・処分完了として登録します。よろしいですか。<br>（処分終了年月日が入力されている廃棄物のみ処分完了扱いとなります）";
        var successMessage = "搬入・処分完了として登録しました。";
      }else{
        var cfMessage = "処分完了として登録します。よろしいですか。<br>（処分終了年月日が入力されている廃棄物のみ処分完了扱いとなります）";
        var successMessage = "処分完了として登録しました。";
      }
      let buttonType = "treatment";
      this.confirm(
        '',
        '',
        cfMessage,
        'info',
        'はい',
        'いいえ',
      ).then(async (result) => {
        if (result.isConfirmed) {
          await this.submitCancelCompleted(successMessage,buttonType, index);
        }
      });
    },
    /**
     * 「キャンセル」「完了」確認ダイアログ「はい」の汎用処理
     * @param successMessage string 処理成功時トーストメッセージ
     */
     async submitCancelCompleted(successMessage, buttonType, index = 0) {
      this.errors = {};
      let params = this.prepareParams();
      params.isTemp = false;
      params.isApprove = false;
      let workOrderType = this.dailyReport.work_order_json.zz_work_order_type_id; // 作業分類

      params.buttonType = buttonType;
      // 完了フラグの設定をcloneした後に行うことで戻し作業を不要にする
      switch(buttonType){
        case "cencel":
          params.daily_report.is_schedule_canceled = !this.dailyReport.is_schedule_canceled;
          break;
        case "transport":
          params.daily_report.is_transport_completed = 1;
          break;
        case "treatmentAccepted":
          params.daily_report[`is_treatment_accepted_${index}`] = 1;
          break;
        case "treatment":
          // 処分完了の時強制的に搬入も完了にする
          // →搬入完了にするのは作業分類処分の場合のみ
          // ↑搬入・処分同時の場合こうする必要があるので
          if(workOrderType == this.$constant.work_order_type.disposal){
            params.daily_report[`is_treatment_accepted_${index}`] = 1;
          }
          // 「搬出」および「積保（の工場）」の場合、処分ではないので日報の完了フラグをそのまま立てる
          if(workOrderType == this.$constant.work_order_type.discharge
            || workOrderType == this.$constant.work_order_type.transshipment_storage
          ){
            params.daily_report[`is_treatment_completed_${index}`] = 1;
          }{
            // それ以外の「処分完了」の場合、wastesOrServicesのtreatment_completeを設定する
            params.wastes_or_services_by_daily_report.map(
              function(item){ 
                if(item.treatment_completed_date != null){
                  item.treatment_complete = 1;
                }else{
                  item.treatment_complete = 0;
                }
              }
            );
          }
          break;
      }
      
      const url = apiEndpoints.input_daily_report(this.dailyReportId, this.vendorSiteId);

      const {status, data, code} = await this.$http.post(url, params);

      if (status) {
        this.successToast(successMessage, false, 2000);
        this.onClickTopBackButton();
      }

      if (this.$helpers.isDisplayFormError(code)) {
        this.errors = data.errors;
        return this.$nextTick(() => {
          this.scrollIntoError();
        });
      } else if (this.$helpers.isDisplayErrorInLocalComponent(code)) {
        if (data.approved_input) {
          return this.alertApprovedWastesOrServices(data.message)
        }
        return this.errorToast(data.message);
      }

    },
    onClickTopBackButton() {
      if (this.isInputPage) {
        return this.backByInputPage();
      }
      if (this.isApproveMaintenancePage) {
        return this.backByApproveMaintenancePage();
      }
      if (this.isCreateMaintenancePage) {
        return this.backByCreateMaintenancePage();
      }
      if (this.isApprovePage) {
        return this.backByApprovePage();
      }
    },
    hiddenCancel(){
      return this.wastesOrServicesByDailyReport.find(item => item.transport_approved_status === "1" || item.treatment_approved_status === "1");
    },
    getTargetWasteOrServiceFromJson(targetId){
      return this.dailyReport.work_order_json.waste_or_service_by_work_order.find((item) => item.id == targetId);
    },
    viewComment(){
      return ((this.isApproveSidePage() || this.isMaintenanceSidePage()) && (this.dailyReport.remarks || this.dailyReport.update_request_for_work_order));
    }
  },
  computed: {
    titlePage() {
      return this.$route.query.screen_parent == 'maintenance' ? '作業日報メンテナンス' :
        (this.$route.query.screen_parent == 'approve' ? '作業日報承認' : '')
    },
    hideBtnManifest() {
      let workOrderType = this.dailyReport?.work_order_json?.zz_work_order_type_id;
      if (workOrderType === this.$constant.work_order_type.others || workOrderType === this.$constant.work_order_type.work) {
        return true;
      }
      return false;
    },
    disabledGoToManifestEdit() {
      if(this.wastesOrServicesByDailyReport[0]?.transport_approved_status !== "1"
        && this.wastesOrServicesByDailyReport[0]?.treatment_approved_status !== "1"
      ){
        return true;
      }

      if (!this.wastesOrServicesByDailyReport[0]?.is_waste) {
        return true;
      }
    },
    index() {
      return this.$route.query.index || 0;
    },
    dailyReportId() {
      return this.$route.params.id;
    },
    vendorSiteId() {
      return this.$route.query.vendor_site_id ?? null;
    },
    wasteOrServiceIds() {
      if (!this.$route.query.waste_or_service_ids) {
        return [];
      }

      return this.$route.query.waste_or_service_ids.toString().split(",").map(x => parseInt(x));
    },
    isCancelable(){
      // とりあえずthis.wastesOrServicesByDailyReportのなかのどれかについて
      // transport_approved_status == 1 か treatment_approved_status == 1 か treatment_approved_status == 3 があれば
      // キャンセル不可にしとく
      let filtered = this.wastesOrServicesByDailyReport.filter(function(item){
        return (item.transport_approved_status == '1' || item.treatment_approved_status == '1' || item.treatment_approved_status == '3');
      });
      return (filtered.length == 0);
      // return !(this.wastesOrServicesByDailyReport[0].transport_approved_status == '1' ||
      //   this.wastesOrServicesByDailyReport[0].treatment_approved_status == '1')
    },
    isInputPage() {
      return this.$route.name === "daily_reports.input";
    },
    isApprovePage() {
      return this.$route.name === "daily.reports.approve";
    },
    isApproveMaintenancePage() {
      return this.$route.name === "daily.reports.maintenance.approve";
    },
    isCreateMaintenancePage() {
      return this.$route.name === "daily.reports.maintenance.add";
    },
    carsByWorkOrder() {
      if (!this.dailyReport.work_order_json) return [];
      if (!this.dailyReport.work_order_json.car_types_by_work_order) return [];
      let carsByWorkOrder = this.dailyReport.work_order_json.car_types_by_work_order;
      carsByWorkOrder = carsByWorkOrder.filter(function(item){return item.is_activate == 1;});
      carsByWorkOrder = carsByWorkOrder.map((x, index) => {
        const carByDailyReport = this.dailyReport?.cars_by_daily_report?.find(y => y.id === x.id);
        if (carByDailyReport) {
          carsByWorkOrder[index].number_of_cars = carByDailyReport.pivot.number_of_cars;
        }

        return x;
      })
      return carsByWorkOrder;
    },
    normalServices() {
      return this.wastesOrServicesByDailyReport.filter(x => !x.is_waste)
    },
    wastes() {
      return this.wastesOrServicesByDailyReport.filter(x => !!x.is_waste)
    },
    zzVendorSiteIndex() {
      return this.vendorSite?.zz_vendor_site_4_id;
    },
    dynamicIsTreatmentAccepted() {
      const isTreatmentAcceptedName = 'is_treatment_accepted_' + this.zzVendorSiteIndex;
      return this.dailyReport.hasOwnProperty(isTreatmentAcceptedName) ? this.dailyReport[isTreatmentAcceptedName] : null;
    },
    dynamicIsTreatmentCompleted() {
      const isTreatmentCompletedName = 'is_treatment_completed_' + this.zzVendorSiteIndex;
      return this.dailyReport.hasOwnProperty(isTreatmentCompletedName) ? this.dailyReport[isTreatmentCompletedName] : null;
    }
  },
  watch: {
    vendorSite: {
      handler(newVal) {
        if (!newVal || !newVal.name) return;
        this.changePageTitle(newVal);
      },
      immediate: true,
    },
    'dailyReport.is_schedule_canceled': {
      handler: function (newVal) {
        this.setValueCompleteFields(newVal);
      },
      immediate: true,
    },
    'dailyReport.is_transport_completed': {
      handler: function (newVal) {
        this.disableCancelFields = (newVal === true || newVal === 1) ? true : false;
      },
      immediate: true,
    },
    dynamicIsTreatmentAccepted(newVal) {
      if (newVal === null) {
        return;
      }
      this.disableCancelFields = (newVal === true || newVal === 1) ? true : false;
    },
    dynamicIsTreatmentCompleted(newVal) {
      if (newVal === null) {
        return;
      }
      this.disableCancelFields = (newVal === true || newVal === 1) ? true : false;
    }
  }
};
</script>
<template>
  <Layout>
    <div class="scroll-area">
      <div class="d-flex justify-content-end mb-2">
        <button class="btn btn-primary waves-effect waves-light" @click="onClickTopBackButton">
          <i class='far fa-arrow-alt-circle-left'></i> {{ this.$lang.button.back }}
        </button>
      </div>
      <b-row class="mt-2">
        <DailyReportInfo
          :daily-report="dailyReport"
          :vendor-site="vendorSite"
          :index="index"
          :control-rules="controlRules"
        />
      </b-row>
      <WastesAfterTreatment
        @modalHidden="onModalWastesAfterTreatmentHidden"
        @dataSelected="onSelectedWastes"
        ref="wastesAfterTreatmentModal"
      />
      <ModalApprovalHistory
        ref="modal_approval_history"
      />
      <b-row v-if="isApproveMaintenancePage && canUserEdit()">
        <b-button
          variant="primary"
          @click="confirmUpdateWorkOrderInformation"
          :disabled="getApproved()"
        >
          作業指示情報を更新する
        </b-button>
      </b-row>
      <b-row v-if="isCreateMaintenancePage && canUserEdit()">
        <SelectWasteOrServiceModal
          @dataSelected="onSelectedWastesOrService"
          :dailyReport="dailyReport"
        />
      </b-row>
      <b-row class="mt-2">
        <div
          class="p-0"
          v-for="(wasteOrServiceByDailyReport, indexWasteOrService) in wastes"
          :key="`wastes_by_dp_${indexWasteOrService}`"
        >
          <WasteInput
            :can-be-delete="isInputPage && wastesOrServicesByDailyReport.length > 1"
            :control-rules="controlRules"
            :daily-report="dailyReport"
            :waste-or-service-by-daily-report="wasteOrServiceByDailyReport"
            @openModalSelectWaste="onOpenModalSelectWaste"
            @deleteWaste="deleteWasteOrServiceByInput"
            :index-waste-or-service="wasteOrServiceByDailyReport.origin_index"
            :errors="errors"
            :is-loading="isLoading"
            :cars="cars"
            :is-approve-side-page="isApproveSidePage()"
            :is-maintenance-side-page="isMaintenanceSidePage()"
          ></WasteInput>
        </div>
        <div
          class="p-0"
          v-for="(wasteOrServiceByDailyReport, indexWasteOrService) in normalServices"
          :key="`normal_services_by_dp_${indexWasteOrService}`"
        >
          <ServiceInput
            :can-be-delete="isInputPage && wastesOrServicesByDailyReport.length > 1"
            :control-rules="controlRules"
            :daily-report="dailyReport"
            :waste-or-service-by-daily-report="wasteOrServiceByDailyReport"
            :index-waste-or-service="wasteOrServiceByDailyReport.origin_index"
            :errors="errors"
            :is-loading="isLoading"
            @deleteService="deleteWasteOrServiceByInput"
            :is-approve-side-page="isApproveSidePage()"
            :is-maintenance-side-page="isMaintenanceSidePage()"
          ></ServiceInput>
        </div>
        <div v-if="carsByWorkOrder.length">
          <h4>車両</h4>
          <CarInput
            :cars-by-work-order="carsByWorkOrder"
            :cars-by-daily-report="dailyReport.cars_by_daily_report"
            :daily-report="dailyReport"
            :errors="errors"
            :is-loading="isLoading"
            :is-approve-side-page="isApproveSidePage()"
          ></CarInput>
        </div>
        <!--remarks area-->
        <b-card>
          <b-row v-if="isDisplayControl('daily_reports.remarks')">
            <b-col cols="12">
              <div class="custom-textarea gap-2">
                <label for="rental_and_special_items_comment">次回作業者への申し送り事項</label>
                  <b-form-textarea
                      rows="4"
                      max-rows="6"
                      v-model="dailyReport.remarks"
                  ></b-form-textarea>
              </div>
              <div
                v-if="errors[`daily_report.remarks`]"
                class="error-message"
              >
                {{ errors[`daily_report.remarks`][0] }}
              </div>
            </b-col>
          </b-row>
          <b-row class="mt-2" v-if="isDisplayControl('daily_reports.update_request_for_work_order')">
            <b-col cols="12">
              <div class="custom-textarea gap-2">
                <label for="rental_and_special_items_comment">事務・営業への申し送り事項</label>
                  <b-form-textarea
                      rows="4"
                      max-rows="6"
                      v-model="dailyReport.update_request_for_work_order"
                  ></b-form-textarea>
              </div>
              <div
                v-if="errors[`daily_report.update_request_for_work_order`]"
                class="error-message"
              >
                {{ errors[`daily_report.update_request_for_work_order`][0] }}
              </div>
            </b-col>
          </b-row>
        </b-card>
      </b-row>
    </div>
    <div class="button-fixed-custom">
      <b-row class="mt-2" align-h="end">
        <b-col class="d-flex justify-content-center gap-2">
          <InputButtons
            @back="backByInputPage"
            @submit="submitInput(false, true)"
            v-if="isInputPage && canUserEdit()"/>

          <ApproveButtons
            :hide-btn-manifest = "hideBtnManifest"
            :disabled-go-to-manifest="disabledGoToManifestEdit"
            :disabled-approve="approveDisabled()"
            @editManifest="toEditManifest"
            @back="backByApprovePage"
            @submit="confirmApprove"
            @openApprovalHistoryModal="openApprovalHistoryModal"
            v-model="approveComment"
            v-if="isApprovePage && canUserEdit()"/>

          <ApproveMaintenanceButtons
            :hide-btn-manifest = "hideBtnManifest"
            :disabled-go-to-manifest="disabledGoToManifestEdit"
            :is-approved="approveDisabled()"
            @editManifest="toEditManifest"
            @back="backByApproveMaintenancePage"
            @submit="confirmApprove"
            @openApprovalHistoryModal="openApprovalHistoryModal"
            v-model="approveComment"
            v-if="isApproveMaintenancePage && canUserEdit()"/>

          <CreateMaintenanceButtons
            :hide-btn-manifest = "hideBtnManifest"
            :disabled-go-to-manifest="disabledGoToManifestEdit"
            @editManifest="toEditManifest()"
            @back="backByCreateMaintenancePage"
            @submit="confirmCreateMaintenancePage"
            v-model="approveComment"
            v-if="isCreateMaintenancePage && canUserEdit()"/>

          <button
            class="w-md-auto waves-effect waves-light"
            :class="dailyReport.is_schedule_canceled ? 'btn btn-outline-primary' : 'btn btn-primary'"
            :disabled="isReadonly('daily_reports.is_schedule_canceled') || !isCancelable"
            v-if="isDisplayControl('daily_reports.is_schedule_canceled') && canUserEdit() && !isCreateMaintenancePage"
            @click="onClickScheduleCanceled()"
            id="cancel-button"
          >
            <i class="fas fa-times"></i> {{ dailyReport.is_schedule_canceled ? this.$lang.button.discancel : this.$lang.button.cancel }}
          </button>

          <button
            class="w-md-auto waves-effect waves-light btn btn-primary"
            :disabled="isReadonly('daily_reports.is_transport_completed') || disableCompleteFields"
            v-if="isDisplayControl('daily_reports.is_transport_completed') && isInputPage && canUserEdit()"
            @click="onClickTransportCompleted()"
          >
          <i class="fas fa-check"></i>
            運搬完了
          </button>


          <template v-if="vendorSite && zzVendorSiteIndex">
              <button
                v-if="isDisplayControl('daily_reports.is_treatment_completed') && isInputPage && canUserEdit()"
                class="w-md-auto waves-effect waves-light btn btn-primary"
                :disabled="isReadonly('daily_reports.is_treatment_completed') || disableCompleteFields"
                @click="onClickTreatmentCompleted(zzVendorSiteIndex, dailyReport.work_order_json.zz_work_order_type_id)"
              >
              <i class="fas fa-check"></i>
              <template v-if="dailyReport.work_order_json.zz_work_order_type_id === '05' || dailyReport.work_order_json.zz_work_order_type_id === '06'">
                排出完了
              </template>
              <template v-else-if="dailyReport.work_order_json.zz_work_order_type_id === this.$constant.work_order_type.transportation_disposal">
                処分完了
              </template>
              <template v-else>
                搬入・処分完了
              </template>
              </button>
          </template>
          <template v-if="isApproveMaintenancePage && canUserDelete()">
            <b-col cols="1">
              <b-button
                class="btn-custom-red waves-effect waves-light"
                @click="beforeSubmitDeleteWasteOrService"
              >
                <i class="fas fa-eraser"></i> {{ this.$lang.button.delete }}
              </b-button>
            </b-col>
          </template>
          <div v-if="viewComment()" id="worker-comment-msg-box">
              <span class="v-middle">作業者のコメントがあります</span>
          </div>
        </b-col>
      </b-row>
    </div>
  </Layout>
</template>
<style lang="scss" scoped>
.scroll-area {
  max-height: calc(100vh - 150px);
  overflow-y: auto;
  overflow-x: hidden;
}
.button-fixed-custom {
  position: sticky;
  bottom: 0;
  z-index: 10;
  margin-top: 10px;
  margin-bottom: -38px;
}
.custom-radio-group {
  height: 100%;

  .label-group {
    flex: 1 0 100px;
  }
}

.custom-table {
  display: flex;

  .title {
    flex: 1 0 100px;
  }

  .table-custom {
    width: 100%;
  }
}
#worker-comment-msg-box{
  color:red;
  border: 1px lightgray solid;
  border-radius: 4px;
  font-size: small;
  background-color: beige;
  min-width: 130px;
  display: flex;
  align-items: center;
}

.v-middle{
  line-height: 100%;
  vertical-align: middle;
}

</style>

<style lang="scss">
  .approve-comment {
    input {
      width: min(400px, 40vw);
    }
  }
#manifest-button{
  min-width:125px;
}
#back-button{
    min-width:75px;
}
#edit-history-button{
    min-width:100px;
}
#register-edit-button{
    min-width:75px;
}
#approve-button{
    min-width:75px;
}
#cancel-button{
    min-width:110px;
}
</style>
